import { render, staticRenderFns } from "./StockLocations.vue?vue&type=template&id=5b733c98&scoped=true"
import script from "./StockLocations.vue?vue&type=script&lang=js"
export * from "./StockLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b733c98",
  null
  
)

export default component.exports